import React from "react";
import GeoComplyMapPin from "./GeoComplyMapPin";
import GeoComplyMapError from "./GeoComplyMapError";

interface Props {
  isError?: boolean;
}

const GeoComplyMap = ({ isError }: Props) =>
  isError ? <GeoComplyMapError /> : <GeoComplyMapPin />;

export default GeoComplyMap;
